module.exports = __webpack_public_path__ + "static/img/RAZ-RK_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAZ-RK_1.png
// module id = qcNC
// module chunks = 0